const isBrowser =
  typeof window !== 'undefined' && typeof navigator !== 'undefined';
const isIOS = isBrowser && /iP(hone|ad|od)/.test(navigator.userAgent);

// eslint-disable-next-line no-undef
let timeoutId: NodeJS.Timeout | null = null;

export const scrollToElementById = (id: string, delay: number = 100) => {
  if (!isBrowser) return;

  const element = document.getElementById(id);

  if (element) {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    timeoutId = setTimeout(() => {
      if (isIOS) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      timeoutId = null;
    }, delay);
  }
};
